import {
  safeGetLocalStorageItem,
  safeSetLocalStorageItem,
} from '@mc/browser-storage'

export type Submission = 'syllabus' | 'notify'

const storageKey = (submission: Submission, slug: string) =>
  `cohort-${submission}-requested:mock:${slug}`

export const hasSubmitted = (submission: Submission, slug: string): boolean =>
  safeGetLocalStorageItem(storageKey(submission, slug)) === 'true'

export const rememberSubmission = (submission: Submission, slug: string) =>
  safeSetLocalStorageItem(storageKey(submission, slug), 'true')
